module.exports = __webpack_public_path__ + "media/images/icons/twotone/gold-e740ec899263af4c664e19e736b558ed.svg";